export default async function() {
    if (this.spinner) return;

    let isCounterpartyReceive = this?.exchange?.isCounterpartyReceive;

    // console.log("isCounterpartyReceive", isCounterpartyReceive);

    if (this.amount.take === 0) {
        this.validations.take.isValid = false;
        this.validations.take.text = this.$t("exchanger.submitData.incorrectData");
    } else if (this.amount.give === 0) {
        this.validations.give.isValid = false;
        this.validations.give.text = this.$t("exchanger.submitData.incorrectData");
    } else if (!this.isAuthenticated && !this.validateEmail(this.email)) {
        this.validations.email.isValid = false;
        this.validations.email.text = this.$t("exchanger.submitData.incorrectEmail");
    } else if (!this.agree) {
        this.errorAgree = true;
    } else if (this.validations.take.isValid && this.validations.give.isValid && this.validationFields()) {
        let isValidCaptcha = this.$refs.captchaOrder.validateCaptcha();

        if (!isValidCaptcha) return;

        if (this.isCryptoExchange) {
            let isContinue = await this.$refs.amlCheckWindow
                .show()
                .then(() => true)
                .catch(() => false);

            if (!isContinue) return;
        }

        if (!isCounterpartyReceive) {
            this.spinner = true;
            this.createOrder();
            return;
        }

        const message = this.$t("notification.createOrder.counterpartyReceive.rules", {
            email: ""
        });

        const title = this.$t("notification.createOrder.counterpartyReceive.title", {});

        let isAgree = await this.$refs.confirmWindow
            .show(message, title)
            .then(() => {
                return true;
            })
            .catch(() => {
                return false;
            });

        // console.log("isAgree", isAgree);

        if (isAgree) {
            this.spinner = true;
            this.createOrder();
        }

        // if (isCounterpartyReceive) {
        //     // this.showConfirmWindow = true;
        //     // !this.showConfirmWindow &&

        //     // let minutes = this.getConfig?.ORDER_COUNTERPARTY_STATUS?.WAIT_PAYMENT?.expire_minutes;

        //     // this.$refs.confirmWindow.show(message, title).then(async () => {
        //     //     console.log("confirm", self);
        //     //     try {
        //     //         self.spinner = true;
        //     //         await self.createOrder();
        //     //     } catch (error) {
        //     //         console.log(error, "error");
        //     //     }
        //     // });
        //     // return;
        // } else {
        //     this.spinner = true;
        //     this.createOrder();
        // }
    }
}
